export const SET_COMMUNITY = 'community/SET_COMMUNITY';
export const SET_COMMUNITY_SLIDES = 'community/SET_COMMUNITY_SLIDES';
export const SET_LOADING_SLIDES = 'community/SET_LOADING_SLIDES';
